import { render, staticRenderFns } from "./FormEditDocument.vue?vue&type=template&id=33cdd4c7&"
import script from "./FormEditDocument.vue?vue&type=script&lang=js&"
export * from "./FormEditDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports